import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { AccountSecurityPage } from './ui/pages/AccountSecurityPage';

/**
 * `/account/*` — personal, account-level pages (as opposed to `/team/*`, which is tenant access
 * administration, and `/settings/*`, which is tenant configuration). `/account/security` is the
 * first page; the prefix is reserved so a later personal page (profile, notifications) needs no new
 * IA decision (adr-merchant-portal-020 D1).
 *
 * Deliberately **not** wrapped in `RequireSection` / `RequirePermission` and **not** an
 * `APP_SECTIONS` entry — see `AccountSecurityPage`'s own doc comment and
 * `app/router/routeGuardCoverage.test.tsx`'s `UNGUARDED_BY_DESIGN['/account/security']`.
 */
export const accountRoutes: RouteObject = {
  path: 'account',
  children: [
    { index: true, element: <Navigate to="/account/security" replace /> },
    { path: 'security', element: <AccountSecurityPage /> },
    { path: '*', element: <Navigate to="/account/security" replace /> },
  ],
};
